<template>
  <el-drawer  class="drawer" id="image_drawer" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" size="101%"
    direction="btt">
    <el-row class="fs-site">
      <el-row class="fs-entry-header">
        <el-col :span="4" class="fs-close" @click.native="closePage">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </el-col>
        <el-col :span="16" class="text-center">
          <h2>{{ $t('pageOrderMoreImage.seemore') }}</h2>
        </el-col>
      </el-row>
      <el-row class="overflow-auto min-90h">
        <template v-for="(url,index) in images">
          <el-col v-if="(index+1)%2==1" :span="12" class="relative r-col-border-2-l" :key="'moreurlimg'+index">
              <div class="r-gallery">
                  <el-image :src="url" :fit="'cover'" :preview-src-list="images" lazy></el-image>
              </div>
          </el-col>
          <el-col v-if="(index+1)%2==0" :span="12" class="relative r-col-border-2-r" :key="'moreurlimg'+index">
              <div class="r-gallery">
                  <el-image :src="url" :fit="'cover'" :preview-src-list="images" lazy></el-image>
              </div>
          </el-col>
        </template>
      </el-row>
    </el-row>

  </el-drawer>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */

export default {
  name: 'OrderMoreImage',
  props: {
    images: null
  },
  components: {
  },
  data() {
    return {
      is_open: true,
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(()=>{

    })
  },
  methods: {
    closePage() {
      this.$emit('toggle_all_image')
    }
  },
  computed: {
  },
  watch:{
    is_open(){
      this.$emit('toggle_all_image')
    }
  }
};

</script>




// WEBPACK FOOTER //
// src/components/order/OrderMoreImage.vue